var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-default-wrapper"},[_c('div',{staticClass:"layout-default-header"},[_c('app-header')],1),_c('div',{staticClass:"layout-default-content-wrapper"},[_c('app-menu'),_c('div',{staticClass:"layout-default-content"},[_c('div',{staticClass:"layout-default-content-container"},[_c('nuxt')],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32673e6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/nuxt/layouts/office.vue
// module id = DBm9
// module chunks = 12